var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResFeatures5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M572.12 201.7C569.21 195.88 561.45 195.88 558.55 201.7C555.05 210.04 527.13 276.75 523.64 285.09C523.64 286.06 522.67 287.03 522.67 288C522.67 318.84 522.67 565.53 522.67 596.36C522.67 619.64 541.09 638.06 564.36 638.06C587.64 638.06 606.06 619.64 606.06 596.36C606.06 565.53 606.06 318.84 606.06 288C607.03 287.03 606.06 286.06 606.06 285.09C599.27 268.41 575.52 210.04 572.12 201.7ZM592.48 295.76L592.48 567.27L538.18 567.27L538.18 295.76L592.48 295.76ZM588.61 281.21L541.09 281.21L565.33 224L588.61 281.21ZM538.18 596.36C538.18 595.39 538.18 590.55 538.18 581.82L592.48 581.82C592.48 589.96 592.48 594.49 592.48 595.39C592.48 610.91 579.88 623.52 565.33 623.52C550.79 623.52 538.18 610.91 538.18 596.36Z",
    id: "d6fAD2YNXU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.64 2.91C489.7 2.91 43.64 2.91 41.7 2.91C36.85 2.91 32.97 5.82 32.97 9.7C32.97 13.58 35.88 17.45 40.73 17.45C83.39 17.45 118.3 52.36 118.3 95.03C118.3 100.85 117.33 106.67 116.36 111.52C108.8 111.52 48.29 111.52 40.73 111.52C36.85 111.52 32.97 114.42 32.97 119.27C32.97 254.06 32.97 288 32.97 421.82C32.97 442.67 32.97 609.45 32.97 630.3C32.97 634.18 35.88 638.06 40.73 638.06C85.72 638.06 445.67 638.06 490.67 638.06C494.55 638.06 498.42 635.15 498.42 630.3C498.42 585.99 498.42 231.47 498.42 187.15C545.94 183.27 583.76 143.52 583.76 95.03C583.76 43.64 542.06 2.91 491.64 2.91ZM490.67 17.45C533.33 17.45 568.24 52.36 568.24 95.03C568.24 137.7 533.33 172.61 490.67 172.61C450.62 172.61 130.23 172.61 90.18 172.61C116.36 156.12 132.85 127.03 132.85 95.03C132.85 63.03 116.36 32.97 90.18 17.45C170.28 17.45 450.62 17.45 490.67 17.45ZM47.52 172.61C47.52 169.5 47.52 153.99 47.52 126.06L111.52 126.06C88.24 155.15 66.91 170.67 47.52 172.61ZM483.88 623.52L47.52 623.52L47.52 421.82L47.52 187.15L482.91 187.15L482.91 623.52L483.88 623.52Z",
    id: "bgiDV1pwI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27 251.15C443.15 251.15 447.03 248.24 447.03 243.39C447.03 238.55 444.12 235.64 439.27 235.64C404.75 235.64 128.58 235.64 94.06 235.64C90.18 235.64 86.3 238.55 86.3 243.39C86.3 248.24 90.18 251.15 94.06 251.15C163.1 251.15 404.75 251.15 439.27 251.15Z",
    id: "a3FqNU93s3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27 315.15C443.15 315.15 447.03 312.24 447.03 307.39C447.03 302.55 443.15 300.61 439.27 300.61C404.75 300.61 128.58 300.61 94.06 300.61C90.18 300.61 86.3 303.52 86.3 308.36C86.3 313.21 90.18 315.15 94.06 315.15C163.1 315.15 404.75 315.15 439.27 315.15Z",
    id: "asbaLLDVA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27 380.12C443.15 380.12 447.03 377.21 447.03 372.36C447.03 367.52 444.12 364.61 439.27 364.61C404.75 364.61 128.58 364.61 94.06 364.61C90.18 364.61 86.3 367.52 86.3 372.36C86.3 377.21 90.18 380.12 94.06 380.12C163.1 380.12 404.75 380.12 439.27 380.12Z",
    id: "anM9DSnfI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27 445.09C443.15 445.09 447.03 442.18 447.03 437.33C447.03 432.48 444.12 429.58 439.27 429.58C404.75 429.58 128.58 429.58 94.06 429.58C90.18 429.58 86.3 432.48 86.3 437.33C86.3 442.18 90.18 445.09 94.06 445.09C163.1 445.09 404.75 445.09 439.27 445.09Z",
    id: "b5WbPUwuEr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27 509.09C443.15 509.09 447.03 506.18 447.03 501.33C447.03 496.48 443.15 494.55 439.27 494.55C404.75 494.55 128.58 494.55 94.06 494.55C90.18 494.55 86.3 497.45 86.3 502.3C86.3 507.15 90.18 509.09 94.06 509.09C163.1 509.09 404.75 509.09 439.27 509.09Z",
    id: "gsT6tO6gB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27 574.06C443.15 574.06 447.03 571.15 447.03 566.3C447.03 561.45 444.12 558.55 439.27 558.55C404.75 558.55 128.58 558.55 94.06 558.55C90.18 558.55 86.3 561.45 86.3 566.3C86.3 571.15 90.18 574.06 94.06 574.06C163.1 574.06 404.75 574.06 439.27 574.06Z",
    id: "b1OEUkRovq"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d6fAD2YNXU",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d6fAD2YNXU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bgiDV1pwI",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bgiDV1pwI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3FqNU93s3",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3FqNU93s3",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#asbaLLDVA",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#asbaLLDVA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#anM9DSnfI",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#anM9DSnfI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5WbPUwuEr",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5WbPUwuEr",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gsT6tO6gB",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gsT6tO6gB",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1OEUkRovq",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1OEUkRovq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResFeatures5);
export default __webpack_public_path__ + "static/media/res-features-5.f8e4f087c60c18b053c8fe90586290d3.svg";
export { ForwardRef as ReactComponent };